<template>
  <div class="fr-skiplinks">
    <nav class="fr-container" role="navigation" aria-label="Accès rapide">
      <ul class="fr-skiplinks__list">
        <li><a class="fr-link" href="#contenu">Contenu</a></li>
        <li><a class="fr-link" href="#header-navigation">Menu</a></li>
        <li><a class="fr-link" href="#footer">Pied de page</a></li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
  import '@gouvfr/dsfr/dist/component/skiplink/skiplink.min.css';
</script>
